<template>
  <li class="pflege-step">
    <div :class="[{'no-icon': icon === ''},'prefix']">
      <PflegeIcon v-if="icon !== ''" :name="icon" :color="iconColor" size="l" />
    </div>
    <div class="content">
      <slot></slot>
    </div>
  </li>
</template>

<script setup lang="ts">
import PflegeIcon from '../Icon/Icon.vue'
import { CompanyColor, IconName, TextAlignment } from '../../../types'

export interface StepProps {
  icon: IconName | ''
  iconColor: CompanyColor
  textAlign: TextAlignment
}

const props = defineProps<StepProps>()
</script>

<style scoped lang='scss'>
  .pflege-step {
    display: flex;
    list-style-type: none;
    margin-block-end: 1.45rem;
  }

  .pflege-step .prefix.no-icon {
    counter-increment: StepCounter 1;
  }

  .pflege-step .prefix.no-icon::before {
    content: counter(StepCounter);
  }

  .pflege-step .prefix {
    align-self: flex-start;
    font-weight: 900;
    font-size: 2rem;
    line-height: 2rem;
    width: 2.2rem;
    min-width: 2.2rem;
  }

  .pflege-step .content {
    padding-top: 0.2rem;
    text-align: v-bind('props.textAlign');
  }
</style>
